import React, { useCallback } from 'react';
import ReactDom from 'react-dom';
import cx from 'classnames';

import {
  getConfigProp,
  HistoryManager,
  NotificationManager,
  useApplicationState,
  useBetHistoryItemState,
} from '@atlas/core';
import { currencySymbols, Icon, Label, Loader, usePopup } from '@atlas/ui';

import CashoutPopup from 'common/Popup/CashoutPopup';

const submitFullCashoutHandler = ({ betId, currencySymbol, estimatedCashOut }) => {
  const notificationContent = (
    <div className="popup__text">
      <Label
        message="money_value"
        params={{
          currency: currencySymbol,
          value: estimatedCashOut,
        }}
      />
    </div>
  );

  const notificationConfirmHandler = async () => {
    await HistoryManager.submit(HistoryManager.actions.operation.cashout, {
      betId,
      estimatedCashOut,
    });
  };

  NotificationManager.display({
    data: {
      children: notificationContent,
      className: 'cashout-confirm',
      closeLabel: 'back',
      confirmLabel: 'bet_status_to_sell',
      onConfirm: notificationConfirmHandler,
    },
    message: 'cashout_confirm_message',
    title: 'cashout_confirm_title',
    type: 'confirm',
  });
};

const Cashout = props => {
  const { orderCashoutDisabled, partialCashoutDisabled } = props;
  const {
    wallet: { currency },
  } = useApplicationState();
  const isSportRadarProject = getConfigProp('isSportRadarProject');
  const currencySymbol = currencySymbols[currency] || currency;

  const { betId, estimatedCashOut, loading, orderCashOut } = useBetHistoryItemState();

  const { isOpenPopup, setOpenPopup, togglePopup } = usePopup();

  const onCashoutClickHandler = useCallback(() => {
    if (loading) {
      return;
    }

    submitFullCashoutHandler({
      betId,
      currencySymbol,
      estimatedCashOut,
    });
  }, [betId, estimatedCashOut, currencySymbol, loading]);

  const onShowPopup = React.useCallback(() => setOpenPopup(true), []);

  const cashoutButtonClassName = cx('cashout__settings', {
    ordered: orderCashOut,
  });
  const orderCashoutAvailable = !orderCashoutDisabled || !partialCashoutDisabled;

  return (
    <div className="cashout">
      <div className="cashout__buttons">
        <button
          className={'cashout-default'}
          disabled={loading}
          onClick={onCashoutClickHandler}
          type="button"
        >
          {loading ? (
            <Loader />
          ) : (
            <Label
              className="cashout-default__text"
              message={'cashout_amount'}
              params={{
                amount: estimatedCashOut,
                currency: currencySymbol,
              }}
            />
          )}
        </button>

        {orderCashoutAvailable && !isSportRadarProject && (
          <button className={cashoutButtonClassName} onClick={onShowPopup} type="button">
            <Icon name="settings" />
          </button>
        )}

        {isOpenPopup &&
          ReactDom.createPortal(
            <CashoutPopup
              orderCashoutDisabled={orderCashoutDisabled}
              partialCashoutDisabled={partialCashoutDisabled}
              setOpenPopup={setOpenPopup}
              togglePopup={togglePopup}
            />,
            document.body,
          )}
      </div>
    </div>
  );
};

export default Cashout;
